__turbopack_context__.v({
  "error": "floating-label-input-module__SrQbfW__error",
  "inner": "floating-label-input-module__SrQbfW__inner",
  "input": "floating-label-input-module__SrQbfW__input",
  "label": "floating-label-input-module__SrQbfW__label",
  "peer": "floating-label-input-module__SrQbfW__peer",
  "select": "floating-label-input-module__SrQbfW__select",
  "textarea": "floating-label-input-module__SrQbfW__textarea",
  "wrapper": "floating-label-input-module__SrQbfW__wrapper",
});
